// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__zNcPA","rightAdornment":"Header_rightAdornment__scGj3"};